<!--本页为左侧下拉菜单-->
<template>
 
   
      <el-menu
        default-active
        class="el-menu-vertical-demo"
        :background-color="themesStyle.menuBackground"
        text-color="#fff"
        router
        active-text-color="#fff"
      >
        <!-- <el-menu-item
          v-for="item of menu"
          :index="item.componentName"
          :key="item.id"
          @click="clickMenu(item.componentName,item.name)"
        >
          <i class="el-icon-star-on"></i>
          <span slot="title">{{item.name}}</span>
        </el-menu-item> -->
        <el-submenu 
					v-for="item of menu"
					:index="change_Zh(item.name)"
					:key="item.id"
				>
          <template slot="title">
            <i class="el-icon-star-on"></i>
            <span slot="title">{{change_Zh(item.name)}}</span>
          </template>
						<el-menu-item
							v-for="itemChild of item.children"
							:index="change_Zh(itemChild.componentName)"
							:key="itemChild.id"
							@click="clickMenu(change_Zh(itemChild.componentName),itemChild.name)"
          	>
							<i class="el-icon-star-on"></i>
							<span slot="title">{{change_Zh(itemChild.name)}}</span>
          	</el-menu-item>
				
          
        </el-submenu>
      </el-menu>
</template>

<script>
import { getnavMenuList } from '@/api/interface'
import { createNamespacedHelpers } from "vuex";
import { Themes } from '@/mixin/themes'
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers("table");
export default {
  name: "navMenu",
  data() {
    return {
      menu: [],
      openedTab: [],
    };
  },
  computed: {
    ...mapState(["activeTab", "openedTabList"]),
    
    
  },
  mixins: [Themes],
  methods: {
		...mapMutations(["ADD_TABLE", "CHANGE_TABLE"]),
		getnavMenuLists() {
			getnavMenuList().then(res => {
        this.menu = res.data
        console.log('this.menu',this.menu)
			})
		},
    clickMenu(componentName, name) {
      this.openedTab = this.openedTabList;
      console.log("list",this.openedTab)
      // tabNum 为当前点击的列表项在openedTab中的index，若不存在则为-1
      let tabNum = -1;
      this.openedTab.forEach((item, index, self) => {
        if (item.componentName == componentName) {
          tabNum = 1;
        }
      });
      if (tabNum === -1) {
        // 该标签当前没有打开
        // 将componentName加入到已打开标签页state.openedTab数组中
        this.ADD_TABLE({ componentName: componentName, name: name });
      } else {
        // 该标签是已经打开过的，需要激活此标签页
        this.CHANGE_TABLE(componentName);
      }
      if(componentName == 'contractEditor') {
         let data = {
          name: "",
          description: "",
          is_edit: 0,
          open_url: "",
          deployment_chain: "1",
          file_path: ""
        };
        this.contract_con(0, data);
      }
    }
  },

  created() {
    this.getnavMenuLists()
    
    
	}
};
</script>

<style scoped>
.over-hide {
  overflow-x: hidden;
}

/* .el-submenu__title {
  border-bottom: 1px solid #8d98a2;
} */

.el-menu-vertical-demo {
  width:100%;
  border-right:0;
}
.el-menu >>> .el-submenu__title {
  height: 40px;
  line-height: 40px;
}
.el-submenu .el-menu-item {
  height: 40px;
  line-height: 40px;
}
</style>
